.chart-interval .euiListGroupItem__button {
  justify-content: center;
  padding: 4px;
  outline: none;
}
